import { render, staticRenderFns } from "./LeavesListApplied.vue?vue&type=template&id=2383d879&scoped=true"
import script from "./LeavesListApplied.vue?vue&type=script&lang=js"
export * from "./LeavesListApplied.vue?vue&type=script&lang=js"
import style0 from "./LeavesListApplied.vue?vue&type=style&index=0&id=2383d879&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2383d879",
  null
  
)

export default component.exports